import type { SessionStepDto } from '../../schemas/sessionSchemas';

// Combined ID Verification step (Voter ID / Passport / Driving Licence).
export function isIdStep(step: SessionStepDto) {
  return /id_verif/i.test(step.stepType) || /id verification/i.test(step.displayName);
}

export type IdDocType = 'voter_id' | 'passport' | 'driving_license';

// Resolve the document type a session binding represents from its operationId.
export function docTypeForBinding(operationId: string): IdDocType | null {
  if (/voterid/i.test(operationId)) return 'voter_id';
  if (/passport/i.test(operationId)) return 'passport';
  if (/_dl_/i.test(operationId) || /drivinglic/i.test(operationId)) return 'driving_license';
  return null;
}

export const ID_DOC_LABEL: Record<IdDocType, string> = {
  voter_id: 'Voter ID',
  passport: 'Passport',
  driving_license: 'Driving Licence',
};

// EPIC: 3 letters + 7 digits (matches gateway RegexPatterns.VoterIdEpicNo).
export function isValidEpic(v: string): boolean {
  return /^[A-Z]{3}[0-9]{7}$/.test(v.trim().toUpperCase());
}

// DL number: 10–16 chars (gateway allows GJ0120130001960 style).
export function isValidDl(v: string): boolean {
  return v.trim().length >= 10 && v.trim().length <= 16;
}

// Passport number: 1 uppercase letter + 7 digits (gateway RegexPatterns.PassportNo).
export function isValidPassportNo(v: string): boolean {
  return /^[A-Z][0-9]{7}$/.test(v.trim().toUpperCase());
}

// DD/MM/YYYY (passport) or DD-MM-YYYY (DL) — lenient date shape check.
export function isValidDate(v: string): boolean {
  return /^\d{2}[/-]\d{2}[/-]\d{4}$/.test(v.trim());
}
